// Import model
import { CreateFpRoomRequest } from '../models/CreateFpRoomRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreateDoorRequest } from '../models/CreateDoorRequest';
import { CreateSurfaceRequest } from '../models/CreateSurfaceRequest';

// Import dependency serializers (for complex types)
import { CreateDoorRequestSerializer } from './CreateDoorRequestSerializer';
import { CreateSurfaceRequestSerializer } from './CreateSurfaceRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateFpRoomRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateFpRoomRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateFpRoomRequest instance
   */
  static deserialize(json: string): CreateFpRoomRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateFpRoomRequest instance
   */
  static fromObject(obj: any): CreateFpRoomRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateFpRoomRequest');
    }


    const instance: CreateFpRoomRequest = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      parentId: obj['parentId'] as string,
      parentObjectType: obj['parentObjectType'] as string | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
      existingSubfloorId: obj['existingSubfloorId'] as string | undefined,
      removeExistingFloorId: obj['removeExistingFloorId'] as string | undefined,
      furnitureToMoveId: obj['furnitureToMoveId'] as string | undefined,
      appliances: obj['appliances'] as number | undefined,
      bathroomFixtures: obj['bathroomFixtures'] as number | undefined,
      heavyItemsToMove: obj['heavyItemsToMove'] as number | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      perimeter: obj['perimeter'] as number | undefined,
      totalArea: obj['totalArea'] as number | undefined,
      doors: obj['doors'] ? (obj['doors'] as any[]).map((item: any) =>
        CreateDoorRequestSerializer.fromObject(item)
      ) : [] as any,
      surfaces: obj['surfaces'] ? (obj['surfaces'] as any[]).map((item: any) =>
        CreateSurfaceRequestSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateFpRoomRequest instances
   */
  static deserializeArray(json: string): CreateFpRoomRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateFpRoomRequest instance to a JSON string
   */
  static serialize(instance: CreateFpRoomRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateFpRoomRequest instance to a plain object
   */
  static toObject(instance: CreateFpRoomRequest): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'parentId': instance.parentId,
      'parentObjectType': instance.parentObjectType,
      'relatedObjects': instance.relatedObjects,
      'existingSubfloorId': instance.existingSubfloorId,
      'removeExistingFloorId': instance.removeExistingFloorId,
      'furnitureToMoveId': instance.furnitureToMoveId,
      'appliances': instance.appliances,
      'bathroomFixtures': instance.bathroomFixtures,
      'heavyItemsToMove': instance.heavyItemsToMove,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'perimeter': instance.perimeter,
      'totalArea': instance.totalArea,
      'doors': instance.doors?.map((item: any) =>
        CreateDoorRequestSerializer.toObject(item)
      ),
      'surfaces': instance.surfaces?.map((item: any) =>
        CreateSurfaceRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of CreateFpRoomRequest instances to a JSON string
   */
  static serializeArray(instances: CreateFpRoomRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
